module.exports = __webpack_public_path__ + "static/img/De-La-Salle-Va_a.41e7ee6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/De-La-Salle-Va_a.jpg
// module id = DtZF
// module chunks = 0